/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Bed } from './Bed';
import {
    BedFromJSON,
    BedFromJSONTyped,
    BedToJSON,
} from './Bed';
import type { ScreenerBedUnit } from './ScreenerBedUnit';
import {
    ScreenerBedUnitFromJSON,
    ScreenerBedUnitFromJSONTyped,
    ScreenerBedUnitToJSON,
} from './ScreenerBedUnit';

/**
 * 
 * @export
 * @interface ScreenerBedRoom
 */
export interface ScreenerBedRoom {
    /**
     * 
     * @type {string}
     * @memberof ScreenerBedRoom
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerBedRoom
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerBedRoom
     */
    name: string;
    /**
     * 
     * @type {ScreenerBedUnit}
     * @memberof ScreenerBedRoom
     */
    bed_unit?: ScreenerBedUnit;
    /**
     * 
     * @type {Array<Bed>}
     * @memberof ScreenerBedRoom
     */
    beds?: Array<Bed>;
}

/**
 * Check if a given object implements the ScreenerBedRoom interface.
 */
export function instanceOfScreenerBedRoom(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ScreenerBedRoomFromJSON(json: any): ScreenerBedRoom {
    return ScreenerBedRoomFromJSONTyped(json, false);
}

export function ScreenerBedRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerBedRoom {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'facility_id': json['facility_id'],
        'name': json['name'],
        'bed_unit': !exists(json, 'bed_unit') ? undefined : ScreenerBedUnitFromJSON(json['bed_unit']),
        'beds': !exists(json, 'beds') ? undefined : ((json['beds'] as Array<any>).map(BedFromJSON)),
    };
}

export function ScreenerBedRoomToJSON(value?: ScreenerBedRoom | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'name': value.name,
        'bed_unit': ScreenerBedUnitToJSON(value.bed_unit),
        'beds': value.beds === undefined ? undefined : ((value.beds as Array<any>).map(BedToJSON)),
    };
}

